module.exports = __webpack_public_path__ + "static/media/storage-stacks (1).e7f83011.png";